var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { Permissions } from "@whatsper/texterchat-common";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerListView } from "../core";
import { getAxios } from "../../../../backend";
import { API_PATH } from "../../../../constants";
import styles from "./OAuthListView.module.scss";
const OAuthTeaser = ({ entity }) => {
    return (React.createElement("div", { className: styles.teaserContainer },
        React.createElement("h4", { className: styles.teaserTitle }, entity.service)));
};
const OAuthListView = ({ onEntitySelect, onEntityDelete, searchQuery = "", refreshList }) => {
    const { agentsStore } = useStore();
    const [credentials, setCredentials] = useState([]);
    const [loading, setLoading] = useState(false);
    const oauthSearchQuery = searchQuery.trim().toLowerCase();
    useEffect(() => {
        loadCredentials();
    }, []);
    useEffect(() => {
        refreshList === null || refreshList === void 0 ? void 0 : refreshList(loadCredentials);
    }, [refreshList]);
    const loadCredentials = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const axios = yield getAxios();
            const { data } = yield axios.get(`${API_PATH.AUTH}/oauth/credentials`);
            setCredentials(data);
        }
        catch (error) {
            console.error("Failed to load OAuth credentials:", error);
        }
        finally {
            setLoading(false);
        }
    });
    const getOpSupported = () => {
        const { hasPermissions } = agentsStore;
        const ops = [];
        if (hasPermissions([Permissions.Permission.oauth_manage_all])) {
            ops.push(Operation.LIST, Operation.CREATE, Operation.DELETE);
        }
        else {
            if (hasPermissions([Permissions.Permission.oauth_manage_own]) ||
                hasPermissions([Permissions.Permission.oauth_manage_default])) {
                ops.push(Operation.LIST, Operation.CREATE, Operation.DELETE);
            }
        }
        return ops;
    };
    const filteredCredentials = credentials.filter((cred) => {
        var _a;
        if (!oauthSearchQuery)
            return true;
        const service = ((_a = cred.service) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
        return service.includes(oauthSearchQuery);
    });
    return (React.createElement(ManagerListView, { entities: filteredCredentials, entityIdKey: "_id", teaser: OAuthTeaser, loading: loading, opSupported: getOpSupported(), onEntitySelect: onEntitySelect, onEntityDelete: onEntityDelete, createTitle: React.createElement(Trans, { i18nKey: "OAuthAuthorize" }) }));
};
export default observer(OAuthListView);
